import Skyline from "./Skyline.jsx";
import logo from "../assets/cllxtv-logo.png";

export default function Splash({ line }) {
  return (
    <div className="splash">
      <div className="skv">
        <Skyline tone="#FFFFFF" far={0.4} near={0.8} />
      </div>
      <img className="slogo" src={logo} alt="" />
      <div className="sname">CLLXTV</div>
      <div className="sline">{line}</div>
      <div className="sbar">
        <div />
      </div>
    </div>
  );
}
